export enum Trilean
{
  False,
  True,
  Unknown
}

export class Trileans
{
  static toBoolean( v:Trilean, unknownValue:boolean = true )
  {
    if ( Trilean.Unknown == v )
    {
      return unknownValue;
    }

    return Trilean.True == v ;
    
  }

  static equals( value:boolean, v:Trilean, unknownValue:boolean = true )
  {
    if ( Trilean.Unknown == v )
    {
      return unknownValue;
    }
    
    return value == Trileans.toBoolean( v );

  }
}